import { Tabs as MuiTabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocales } from 'src/legacy/locales';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import { useUserDetailsNavigatorContext } from './UserDetailsNavigatorContext';

export const Tabs = () => {
  const navigate = useNavigate();

  const { translate } = useLocales();

  const { currentTab, id, tabs } = useUserDetailsNavigatorContext();

  return (
    <MuiTabs
      onChange={(_, newValue) => {
        navigate(`${PATH_DASHBOARD.user.details(id)}/${newValue}`);
      }}
      sx={{
        mb: 2,
        mx: 5,
      }}
      value={currentTab}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          label={`${translate(tab.label)}`}
          value={tab.value}
        />
      ))}
    </MuiTabs>
  );
};
